<template>
  <v-skeleton-loader v-if="isLoadingAsyncData" type="article" />
  <div v-else-if="isContainerVisible" class="LKPublicationsMunMehList">
    <template v-if="list && list.length">
      <LKMunMehCardForm
        v-for="item in list"
        :key="item.id"
        :data="item"
        :publication-id="publicationId"
        :slug="slug"
        class="LKPublicationsMunMehList__item"
        v-on="$listeners"
      />
    </template>
    <template v-else-if="errorMessage">
      <div
        class="error--text ml-8"
        v-text="errorMessage"
      />
      <v-btn
        dark
        block
        depressed
        :color="color"
        @click.stop="getData"
        v-text="'Повторить'"
      />
    </template>
  </div>
</template>

<script>
import LKMunMehCardForm from './LKPublicationsMunMeh/LKMunMehCardForm.vue'
import PublicationsCardComponentMixin
  from '@/views/LKPublications/components/LKPublicationsCard/PublicationsCardComponentMixin'
import { LkMunMehApi } from '@/api/resources'

export default {
  name: 'LKPublicationsMunMehList',
  components: {
    LKMunMehCardForm,
  },
  mixins: [PublicationsCardComponentMixin],
  props: {
    slug: String,
  },
  methods: {
    async loadData() {
      const api = new LkMunMehApi()
      const { data } = await api.getMunMeh(this.publicationId)
      return data
    },
  },
}
</script>
